import React from 'react';
import KeyFindingsHome from "./KeyFindingsHome"
import { pmRoot} from "../../../../utils/defaultValues";
import IntlMessages from "../../../../utils/IntlMessages";

const KeyFindingsRouteConfig = {
  routes: [
		{
    path: `${pmRoot}/project/key-findings`,
    exact: true,
    name: <IntlMessages id={"menu.key-findings"}/>,
    element: <KeyFindingsHome/>,
    auth: [],
  },
	]
};
export default KeyFindingsRouteConfig;